import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay } from '@/test/mocks/utils';

export type AssignStudentParams = {
  lead_id: string;
  variant_id: string;
  batch_id: string;
};

export type AssignStudentResponse = {
  status: string;
  info: string;
  message: string;
};

export const assignStudent = (
  params: AssignStudentParams
): Promise<AssignStudentResponse> => {
  return axios.post('/batches/v1/onboarding/assign-student', params);
};

export const assignStudentMockHandler = http.post(
  `${env.API_URL}/batches/v1/onboarding/assign-student`,
  async (): Promise<HttpResponse<AssignStudentResponse>> => {
    await networkDelay();

    const mockResponse: AssignStudentResponse = {
      status: 'success',
      info: 'operation successful',
      message: 'Batch assignment updated',
    };

    return HttpResponse.json(mockResponse);
  }
);
